'use client';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { usePathname, useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';
import { updateLocale } from '@/lib/user';
import { useIsLoggedIn } from '@/lib/hooks/useIsLoggedIn';

const languageOptions = ['en', 'zh-CN', 'zh-TW'];
const languageNames: Record<string, string> = {
  en: 'EN',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
};

function CustomExpandMoreIcon(props: any) {
  return <ExpandMoreIcon width="0.75rem" height="0.75rem" {...props} />;
}

export default function LanguageSwitch() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const isLoggedIn = useIsLoggedIn();

  const handleChange = async (event: SelectChangeEvent) => {
    const newLocale = event.target.value;
    // 获取当前的 search param 和 hash
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    const currentPath = pathname ? pathname.replace(`/${locale}`, '') : '';

    if (isLoggedIn) {
      try {
        await updateLocale(newLocale);
      } catch (e) {
      }
    }

    router.replace(`/${newLocale}${currentPath}${search}${hash}`);
  };

  return (
    <Select
      value={locale}
      onChange={handleChange}
      variant="standard"
      disableUnderline
      IconComponent={CustomExpandMoreIcon}
      sx={{
        height: '40px',
        bgcolor: 'background.default',
        borderRadius: '20px',
        px: 0,
        '& .MuiSelect-select': {
          py: 1,
          color: 'text.primary',
          fontSize: 'var(--font-size-xs)',
          fontWeight: 600,
        },
        '& .MuiSelect-icon': {
          color: 'text.primary',
        },
      }}
      MenuProps={{
        sx: {
          '& .MuiPaper-root': {
            bgcolor: 'background.paper',
            borderRadius: 2,
            mt: 1,
          },
          '& .MuiMenuItem-root': {
            fontSize: '0.9rem',
            py: 1,
            px: 2,
            '&:hover': {
              bgcolor: 'action.hover',
              color: 'primary.main',
            },
          },
        },
      }}
    >
      {languageOptions.map((loc) => (
        <MenuItem key={loc} value={loc}>
          {languageNames[loc]}
        </MenuItem>
      ))}
    </Select>
  );
}